import type { LeadAssignmentValidationMessages } from './types'

/** Recursively makes all properties required in a type. */
export type DeepRequired<T> = T extends object ? { [P in keyof T]-?: DeepRequired<T[P]> } : T

/** Default validation error messages for lead assignment schemas. */
export const defaultMessages: DeepRequired<LeadAssignmentValidationMessages> = {
  affiliateCxIds: {
    invalid_type: 'Affiliate IDs must be an array of numbers',
    nonempty: 'At least one affiliate ID must be specified',
    required: 'Affiliate IDs are required',
  },
  campaignIds: {
    invalid_type: 'Campaign IDs must be an array of numbers',
    nonempty: 'At least one campaign ID must be specified',
    required: 'Campaign IDs are required',
  },
  clientTypes: {
    invalid_enum: 'Unsupported client type specified',
    invalid_type: 'Client types must be an array',
    required: 'Client types are required',
  },
  countries: {
    invalid_enum: 'Unsupported country specified',
    invalid_type: 'Countries must be an array',
    required: 'Countries are required',
  },
  delayInSeconds: {
    invalid_type: 'Delay must be a number',
  },
  events: {
    invalid_type: 'Events must be an object',
    required: 'Events are required',
  },
  externalAgent: {
    invalid_enum: 'Invalid pool specified for external agent',
    invalid_type: 'External agent must be a string',
  },
  forceful: {
    invalid_type: 'Forceful field must be a boolean value',
  },
  ibIds: {
    invalid_type: 'IB IDs must be an array of numbers',
    nonempty: 'At least one IB ID must be specified',
    required: 'IB IDs are required',
  },
  includeSubAffiliates: {
    invalid_type: 'Include sub-affiliates field must be a boolean value',
    required: 'Include sub-affiliates field is required',
  },
  includingSubIBs: {
    invalid_type: 'Including sub-IBs field must be a boolean value',
    required: 'Including sub-IBs field is required',
  },
  isInverted: {
    invalid_type: 'Is inverted field must be a boolean value',
  },
  locales: {
    invalid_enum: 'Unsupported locale specified',
    invalid_type: 'Locales must be an array',
    required: 'Locales are required',
  },
  name: {
    invalid_type: 'Name must be a string',
    required: 'Workflow name is required',
  },
  pools: {
    invalid_type: 'Pools must be an object',
    required: 'Agent pools are required',
  },
  rules: {
    invalid_type: 'Rules must be an array of arrays',
    required: 'Rules are required',
  },
  salesAgent: {
    invalid_enum: 'Invalid pool specified for sales agent',
    invalid_type: 'Sales agent must be a string',
  },
  supportAgent: {
    invalid_enum: 'Invalid pool specified for partner agent',
    invalid_type: 'Partner agent must be a string',
  },
  type: {
    invalid_literal: 'Invalid rule type specified',
    invalid_type: 'Rule type must be a string',
    required: 'Rule type is required',
  },
  whitelabel: {
    invalid_enum: 'Unsupported whitelabel specified',
    invalid_type: 'Whitelabel must be a string',
    required: 'Whitelabel is required',
  },
}
